import React, { useEffect } from "react";
import Header from "../Header";
import "./help.scss";
import TopQuery from "./TopQuery";
import FAQ from "./FAQ";
import { GetBaseUrl } from "../modules/getBaseUrl";
import BreadCrumbComponent from "../modules/Breadcrumbs";
function Help(props) {
  useEffect(() => {
    const currentURL = window.location.href;
    let baseUrl = GetBaseUrl(currentURL);
    const newUrl = currentURL.replace(baseUrl, "").split("/");

  }, []);
  return (
    <div className={`${!props.loggedIn ? 'form-div':''} help`}>
      {!props.loggedIn && (
        <div className="bc">
          <BreadCrumbComponent list={["Home", "Help"]} />
        </div>
      )}
      <div className="review-heading">
        <div className="form-title">Help</div>
      </div>
      <TopQuery loggedIn={props.loggedIn} />
      <FAQ />
    </div>
  );
}

export default Help;
